<template>
  <div ref="wrapper" class="flex flex-nowrap gap-4 overflow-x-auto no-scrollbar whitespace-nowrap">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useRafFn } from "@vueuse/core";
import { useTemplateRef } from "vue";

const scrollContainer = useTemplateRef("wrapper");

let right = false;

const pixelsPerSecond = 40;

let lastSwitch = 0;
const delay = 3000; // ms pause at edges

useRafFn(({ delta, timestamp }) => {
  const el = scrollContainer.value;
  if (!el) return;

  const max = Math.max(0, el.scrollWidth - el.clientWidth);
  if (max <= 0) return; // nothing to scroll

  // If we are in cooldown, do nothing until delay has passed
  if (timestamp - lastSwitch < delay) return;

  // compute next position
  const step = pixelsPerSecond * (delta / 1000) * (right ? 1 : -1);
  let next = el.scrollLeft + step;

  // clamp & flip at edges
  if (next >= max - 0.5 && right) {
    next = max;
    right = false;
    lastSwitch = timestamp; // start cooldown
  } else if (next <= 0 + 0.5 && !right) {
    next = 0;
    right = true;
    lastSwitch = timestamp; // start cooldown
  }

  el.scrollLeft = next;
});
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
